{
  "home": "Home",
  "calendar": "Calendar",
  "map": "Map",
  "mine": "My activity",
  "more": "More",
  "offices": "Offices",
  "hotlines": "Hotlines",
  "emergency": "Report an emergency",
  "cropDamage": "Report crop damage",
  "following": "Following",
  "notifications": "Notifications",
  "settings": "Settings",
  "privacy": "Privacy",
  "about": "About",
  "staffWorkspace": "Staff workspace",
  "residentApp": "Resident view",
  "admin": "Administration",
  "groupEssentials": "Essentials",
  "groupSafety": "Safety & preparedness",
  "groupAccount": "Account",
  "openMenu": "Open menu",
  "account": "Account",
  "myRequests": "My requests",
  "groupServices": "Services",
  "services": "Services",
  "civilRegistry": "Civil Registry",
  "taxes": "Pay & taxes",
  "reportConcern": "Report a concern",
  "charter": "Citizen's Charter",
  "feedback": "Feedback",
  "search": "Search",
  "groupCommunity": "Community",
  "groupExplore": "Explore",
  "guides": "Town guides",
  "facilities": "Book a facility",
  "proposals": "Proposals",
  "lostFound": "Lost & found",
  "recycling": "Recyclables pickup",
  "marketPrices": "Market prices",
  "tourism": "Tourism",
  "transparency": "Transparency",
  "documents": "Documents"
}
